import { type FC } from "react";
import { Typography } from "@/components/essentials/typography";
import { Flex, Image } from "@chakra-ui/react";
import { Box } from "@/components/essentials/box";
import error01 from "~/assets/images/error-01.svg";
import { invalidPanelTestId } from "./const";
import Link from "next/link";
import { toysubContactUsUrl } from "@/configs/externalUrls";

export interface InvalidPanelProps {
  readonly title?: string;
}

export const InvalidPanel: FC<InvalidPanelProps> = ({ title = "正常に表示できませんでした。" }) => {
  return (
    <Flex data-testid={invalidPanelTestId} flexDir="column" w="100%" justifyContent="center" alignItems="center">
      <Box mb="6">
        <Image src={error01} alt="toybox" width={110} height={110} />
      </Box>
      <Box textAlign="center">
        <Typography variant="display4" mb="3">
          {title}
        </Typography>

        <Typography variant="text4" color="gray.main">
          お手数ですが、時間をおいてから再度お試しください。
          <br />
          問題が解決しない場合、
          <Typography
            as={Link}
            href={toysubContactUsUrl}
            variant="text4"
            target="_blank"
            rel="noopener norefferer"
            color="theme.green.main"
            textDecorationLine="underline"
          >
            こちら
          </Typography>
          よりお問い合わせ下さい。
        </Typography>
      </Box>
    </Flex>
  );
};
